/* global Provider */
import React, { Component } from 'react';
import RankTableRow from './RankTableRow.js';
import _ from 'underscore';

class RankTable extends Component { 
    render() {
        if (!this.props.rankings)return null;
        let alphaFunds = _.sortBy(Object.values(this.props.selectedFunds));
        alphaFunds.forEach((fund)=>{
            return fund.display;
        });
        alphaFunds.sort(function(a, b) { return a.rank - b.rank });

        let simpleWeightings = Provider.dataManager.calculateSimpleWeightings(Provider.state.weightings, true);

        return (
            <div>
                <div className="rank-table">            
                    <div className="header row">
                        <div className={this.props.portrait ? "col-6" : "col-6 replaceBeforeRender"}>&nbsp;</div>
                        <div className="c1"><span data-tip="Growth Risk">Growth<br/>{simpleWeightings.growth}%</span></div>
                        <div className="c1"><span data-tip="Market Risk">Market<br/>{simpleWeightings.market}%</span></div>
                        <div className="c1"><span data-tip="Macro Risk">Macro Scenario<br/>{simpleWeightings.macro}%</span></div>
                        <div className="c1"><span data-tip="Income Risk">Income Horizon<br/>{simpleWeightings.income}%</span></div>
                        <div className="c1"><span data-tip="Custom">Custom-Weighted<br/>Suitability Rank<br/>{100}%</span></div>
                        <div className="c1"><span data-tip="Suitability"></span></div>
                    </div>
                </div>
                <div>
                    <div className="rank-table">   
                        {_.map(alphaFunds, (fund, index) => {
                            return (<RankTableRow key={index} data={fund} label={fund.display} activeKey={index} total={alphaFunds.length - 1} {...this.props} />);
                        })}          
                    </div>  
                </div> 
                <div className="rank-table legend">                                
                    <div className="row">
                        <div className={this.props.portrait ? "col-12" : "col-12 replaceBeforeRender"}>
                            <div style={{ display: 'none' }} className="legend-header row">
                                <div className="c2">&nbsp;</div>
                                <div className="c2">1 - 10</div>
                                <div className="c2">11 - 20</div>
                                <div className="c2">21 - 30</div>
                                <div className="c2">31 - 40</div>
                                <div className="c2">41 - 50</div>
                                <div className="c2">51 - 60</div>
                                <div className="c2">61 - 70</div>
                                <div className="c2">71 - 80</div>
                                <div className="c2">81 - 90</div>
                                <div className="c2">91 - 100</div>
                            </div>                   
                            <div className="legend-content row">
                                <div className="c2">Legend</div>
                                <div className="c2 rank-1">Lowest<br/>Relative Risk</div>
                                <div className="c2 rank-2">&nbsp;</div>
                                <div className="c2 rank-3">&nbsp;</div>
                                <div className="c2 rank-4">&nbsp;</div>
                                <div className="c2 rank-5">&nbsp;</div>
                                <div className="c2 rank-6">&nbsp;</div>
                                <div className="c2 rank-7">&nbsp;</div>
                                <div className="c2 rank-8">&nbsp;</div>
                                <div className="c2 rank-9">&nbsp;</div>
                                <div className="c2 rank-10">Highest<br/>Relative Risk</div>
                                <div className="c2">&nbsp;</div>
                            </div>                
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RankTable;
